export const enum ReservationPreferences {
    TableSeat = "Table Seat",
    NearLuggage = "Near Luggage Rack",
    PowerSocket = "Near Power Socket",
    NearToilet = "Near Toilet",
}

export const enum SeatDirection {
    NoPreference = "Any",
    BackwardFacing = "BACKWARD",
    ForwardFacing = "FORWARD",
    BackwardFacingAirline = "AIRLINE_STYLE_BACKWARD",
    ForwardFacingAirline = "AIRLINE_STYLE",
}

export const enum SeatPosition {
    NoPreference = "Any",
    Aisle = "AISLE",
    Individual = "INDIVIDUAL",
    Middle = "MIDDLE",
    Window = "WINDOW",
}

export const enum CoachType {
    NoPreference = "Any",
    Quiet = "QUIET"
}

export const enum FareDetailsFlag {
    RequiresSeatReservation = "RequiresSeatReservation"
}

export const enum ReservationRequestModel {
    TableSeat = "TABLE_SEAT",
    NearLuggage = "NEAR_LUGGAGE_RACK",
    PowerSocket = "POWER_SOCKET",
    NearToilet = "NEAR_TOILET",
}
